import { isSafeUrl } from './safe-url';
import { resolveInAppPath } from './app-link';
import { vfsFileName, vfsPathOfLink } from './vfs-link';

// What a markdown link's target should DO when it is clicked. Extracted from the `a` renderer in
// `components/Markdown.tsx` so the decision is unit-testable: react-markdown is ESM-only and cannot be
// loaded by this package's jest config, but the decision is the whole behaviour worth pinning.
export type MarkdownLinkTarget =
  /** The scheme is not on the allowlist — render the label as ordinary text, with no anchor at all. */
  | { kind: 'plain' }
  /** One of the app's own destinations — navigate within the app rather than opening a tab. */
  | { kind: 'in-app'; route: string }
  /** A workspace (VFS) path — open that file in the doc viewer, the way a `vfsPath` attachment chip does.
   *  `vfsPath` is in the attachment form (`workspaces/<slug>/…`, not the agent's `spaces/<slug>/…`). */
  | { kind: 'vfs-file'; vfsPath: string; fileName: string }
  /** Anything else — a normal outbound link. */
  | { kind: 'external'; href: string };

export function markdownLinkTarget(href: string | undefined | null): MarkdownLinkTarget {
  if (!isSafeUrl(href)) return { kind: 'plain' };
  const inApp = resolveInAppPath(href);
  if (inApp) return { kind: 'in-app', route: inApp };
  const vfsPath = vfsPathOfLink(href);
  if (vfsPath) return { kind: 'vfs-file', vfsPath, fileName: vfsFileName(vfsPath) };
  return { kind: 'external', href: href as string };
}
